module.exports = __webpack_public_path__ + "img/energySaving-style-bg.da59cfc7.png";